import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { SocialProofBar } from '../components/SocialProofBar';
import { ProblemSection } from '../components/ProblemSection';
import { MechanismSection } from '../components/MechanismSection';
import { PortfolioSection } from '../components/PortfolioSection';
import { GoogleProfilesSection } from '../components/GoogleProfilesSection';
import { PricingSection } from '../components/PricingSection';
import { ProcessSection } from '../components/ProcessSection';
import { StorySection } from '../components/StorySection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { UrgencySection } from '../components/UrgencySection';
import { FinalCTA } from '../components/FinalCTA';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { FloatingWhatsApp } from '../components/FloatingWhatsApp';
import { PromoPopup } from '../components/PromoPopup';
export function Home() {
  return <div className="min-h-screen bg-dark text-white font-sans selection:bg-gold selection:text-dark" data-id="element-499">
      <Navbar data-id="element-500" />
      <main data-id="element-501">
        <Hero data-id="element-502" />
        <SocialProofBar data-id="element-503" />
        <ProblemSection data-id="element-504" />
        <MechanismSection data-id="element-505" />
        <PortfolioSection data-id="element-506" />
        <GoogleProfilesSection data-id="element-507" />
        <PricingSection data-id="element-508" />
        <ProcessSection data-id="element-509" />
        <StorySection data-id="element-510" />
        <TestimonialsSection data-id="element-511" />
        <GuaranteeSection data-id="element-512" />
        <UrgencySection data-id="element-513" />
        <FinalCTA data-id="element-514" />
        <FAQSection data-id="element-515" />
      </main>
      <Footer data-id="element-516" />
      <FloatingWhatsApp data-id="element-517" />
      <PromoPopup data-id="element-518" />
    </div>;
}